import React from 'react';
import HeroSection from './components/HeroSection';
import DemoSection from './components/DemoSection';
import FeaturesSection from './components/FeaturesSection';
import IntegrationsSection from './components/IntegrationsSection';
import PricingTeaser from './components/PricingTeaser';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import SetupGuideSection from './components/SetupGuideSection';
import CostCalculator from './components/CostCalculator';

const Home = () => {
  return (
    <div className="flex flex-col">
      <HeroSection />
      <DemoSection />
      <FeaturesSection />
      <div id="setup" className="bg-gradient-to-b from-gray-50 to-white py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Track Changes From Anywhere
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Simple REST API integration lets you log changes from any environment. 
                Start tracking in minutes with these copy-paste examples.
              </p>
          </div>
          <SetupGuideSection />
        </div>
      </div>
      <CostCalculator />
      <PricingTeaser />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default Home;